import React from 'react';

const CookiePolicy = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6">
            <h1 className="text-3xl font-semibold mb-4">Session Management Policy</h1>
            <p className="text-gray-700 mb-4">
                At <a href="https://academy-nest.com" className="font-semibold text-blue-600 hover:underline">academy-nest.com</a>, we prioritize your learning experience while maintaining the security and privacy of your data. As an e-learning platform, we use session management to facilitate live courses and ensure a seamless experience for both teachers and students. Currently, we do not rely on cookies to track user activities or store personal information.
            </p>
            <p className="text-gray-700 mb-4">
                Instead, we utilize secure session storage to handle the temporary data needed for live course interactions. This includes storing data necessary for session participation such as enrollment details, progress within sessions, and live interactions. Once a session ends, all session data is securely cleared to maintain user privacy.
            </p>
            <p className="text-gray-700">
                We ensure that all session data is encrypted and protected against unauthorized access. If you have any questions or concerns regarding our session management practices, feel free to reach out to us.
            </p>
        </div>
    );
};

export default CookiePolicy;
